<div class="app-container !p-0">

  <div class="p-4 bg-white">
    <div class="container mx-auto flex gap-5 justify-between items-center">
      <div class="flex items-center justify-center gap-4 ml-auto">
        <app-dropdown
          [title]="'Status'"
          [isTitlePrefix]="true"
          [items]="statuses"
          [display]="'label'"
          [(ngModel)]="statusFilter"
          (valueChanged)="onDropDownFilterSelected()">
        </app-dropdown>
        @if (userRole == UserRole.yscAdmin) {
          <app-button (click)="onCreateNewCompanyClicked()">
            Create New Company
          </app-button>
        }
      </div>

    </div>
  </div>

  <div class="app-page-content grow overflow-auto">
    <app-data-table
      [state]="companyListState"
      [columnDefs]="columnDefs"
      (onActionPerformed)="onActionClicked($event)"
      (tableStateChanged)="getCompanyList($event)"
      [enableSearch]="true"
      [(ngModel)]="tableState">
    </app-data-table>
  </div>

</div>
